import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'role',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'role',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'role',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'role',
  action: ActionType.UPDATE,
};

export const Role = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
